import * as React from "react";
import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, Card,H4,Intent, Elevation, Overlay } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import{CardPdf} from './CardPdf.tsx'
import {CardQuizz} from './CardQuizz.tsx'
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import CardDocument from './CardDocument.tsx';
import CardImage from './CardImage.tsx';
import { type, userInfo } from "os";
import CardObject from "./CardObject.tsx";
import CardEditorViewer from "./CardEditorViewer.tsx";
import CardDocumentWeb from './CardDocumentWeb.tsx';



export default class CardDocuments extends React.Component  <HomeProps> {
 
  constructor(props) {
        super(props);
        //this.setState({title_lesson:this.props.title_lesson})
       // this.setState({lesson_description:this.props.lesson_description})
       // this.handleChange = this.handleChange.bind(this);
      }
      state = {
        name: '',
        coloropen:"#ffffff",
        force_width:250,
        isDocOpen:'none',
        isOpenEdit:false,
        isOpenDelete:false,
        title_lesson:this.props.title_lesson,
        lesson_description:this.props.lesson_description,
        mustchange:false,
        id_cours:this.props.id_cours,
        datadocuments:[]
      }  
  componentDidMount () { 
   
    if(this.props.config=='true')this.setState({force_width:480});
    //if(this.state.id_cours!="")this.LoadDataDocuments(this.state.id_cours);
    
    //this.setState({title_lesson:this.props.title_lesson})
    //this.setState({lesson_description:this.props.lesson_description})
    
  }
LoadDataDocuments=(ev)=>
{
  //console.log("LoadDataDocuments");
  //console.log(stid);
  //return;
  console.log(ev);
  console.log(ev.target.id);
  var id=ev.target.parentElement.id;
  //si on clique pas sur le span mais sur le bouton
  if(id==undefined)id=ev.target.id;
  if(id=='')id=ev.target.id;
  var that=this;
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getdocuments?id_cours='+ id); //this.state.navbarTabId)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        that.setState({datadocuments:jsonResponse});
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}
  loaddocument(ev)
  {
    var id=ev.target.parentElement.id;
    //si on clique pas sur le span mais sur le bouton
    if(id==undefined)id=ev.target.id;
    if(id=='')id=ev.target.id;
    var doc=[{}];
    this.setState({datadocuments:doc});
  }
 
  componentDidUpdate(prevProps, prevState) {
    if(this.state.mustchange==false)
    {
      if(this.state.title_lesson!=this.props.title_lesson)this.setState({title_lesson:this.props.title_lesson})
      if(this.state.lesson_description!=this.props.lesson_description)this.setState({lesson_description:this.props.lesson_description})
    }
    else
    {
      this.props.title_lesson=this.state.title_lesson;
      this.props.lesson_description=this.state.lesson_description;
      this.setState({mustchange:false})
    }
    //this.setState({lesson_description:this.props.lesson_description})
  }
  renderItem = (p) => {
    console.log(p.type)
    if(p.type==undefined){return (
      <div></div>
      );
    }
    if (p.type=="image") {
      return (
        <CardImage    {...this.props} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="object" ) {
      return (  
        <CardObject {...this.props}   id_document={p.ID}url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="yt" ) {
      return (  
        <CardDocument {...this.props} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="video" ) {
      return (  
        <CardDocument {...this.props} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="quizz" ) {
      return (  
        <CardQuizz    {...this.props} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="pdf" ) {
      return (  
        <CardPdf      {...this.props} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="jsontexte" ) {
      return (  
        <CardEditorViewer      {...this.props} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="audio" ) {
      return (  
        <CardDocument {...this.props} id_document={p.ID} type_audio="true" url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="web" ) {
      return (  
        <CardDocumentWeb {...this.props} id_document={p.ID} youtube_frame='true' url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    
    return (
        <div></div>
    );
}
  //Test One drive iframe pas possible car document s'ouvre dans une autre fenêtre
 // {id_documents == 5 ?<CardDocument {...this.props} url_video="https://onedrive.live.com/embed?cid=CCE819EC89F4DDE9&resid=CCE819EC89F4DDE9%21332163&authkey=AC59_u58GzB75Yg" objectif="Document sur One Drive" title_document="Test" description="Test"/>:<div></div>}
 //<iframe src="https://onedrive.live.com/embed?cid=CCE819EC89F4DDE9&resid=CCE819EC89F4DDE9%21332163&authkey=AC59_u58GzB75Yg" width="98" height="120" frameborder="0" scrolling="no"></iframe>
   render() {
    
    
    const {config,type_audio,id_documents,youtube_frame,lesson_description,title_lesson,url_video,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handhandleSelectionGetLoginleSelectionChangeLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
  
    return(
      <div style={{display: this.props.coursopen && this.state.isDocOpen=='none'?'none':isnotdocument,marginLeft:this.state.isDocOpen=='none'?0:-200}}>
      <Card style={{display:'block',width:this.state.force_width,margin:4,backgroundColor:this.state.coloropen}}><H4>{this.state.title_lesson}</H4><p><a>{this.state.lesson_description}</a></p>
      {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
      {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
      {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE} icon="cube-add" title="Ajouter un document" />:<div></div>}
      {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon="eye-off" title="Cours en ligne" />:<div></div>}
      {this.props.toolbar!='true'?<Button id={this.props.id_cours} style={{display: 'block',marginTop:15}} onClick={(ev)=>{ev.preventDefault();if(this.state.isDocOpen=='none'){this.setState({isDocOpen:'flex'});this.LoadDataDocuments(ev);this.setState({coloropen:'#b6e3ff'});}else{this.setState({isDocOpen:'none'});this.setState({coloropen:'#ffffff'})};this.props.handlestate(this.state.isDocOpen=='none');}} >{this.state.isDocOpen=='none'?'Ouvrir':'Fermer'}</Button>:<div></div>}
      <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le cours {this.state.title_lesson}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le cours {this.state.title_lesson} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              /*var formData = new FormData();
                              formData.append('Model.ID', this.props.id_documents);
                              formData.append('nom', this.state.title_lesson);
                              formData.append('id_matiere', this.props.matiere_id);
                              formData.append('description', this.state.lesson_description);
                              formData.append('tag', this.props.id_documents);*/
                              var that=this;
                              xhr.open('GET','/api/public/delcours?id_cours='+this.props.id_documents)
                              
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          that.props.onchildrenevent();
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
                </Overlay>
      <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Edition du cours</H4>
                        <input type="text" onChange={(ev)=>{this.setState({mustchange:true});this.setState({title_lesson:ev.target.value})}} value={this.state.title_lesson}/>
                        <p style={{marginTop:20}}>
                           Donnez une description à votre cours
                        </p>
                        <input type="text" onChange={(ev)=>{this.setState({mustchange:true});this.setState({lesson_description:ev.target.value})}} value={this.state.lesson_description} placeholder="Description"/>
                       
                       
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenEdit:false});
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var formData = new FormData();
                              formData.append('Model.ID', this.props.id_documents);
                              formData.append('nom', this.state.title_lesson);
                              formData.append('id_matiere', this.props.matiere_id);
                              formData.append('description', this.state.lesson_description);
                              formData.append('tag', this.props.id_documents);

                              xhr.open('POST','/api/public/updatecours')
                              
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send(JSON.stringify(Object.fromEntries(formData)));

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                         
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
                </Overlay>
        <div></div>
      </Card>
      <div style={{display:this.state.isDocOpen, flexWrap: 'wrap', flex:'100%',width:'100%',backgroundColor:"rgba(245,245,245,0.9"}}>
      <div style={{display:'flex', flexWrap: 'wrap', flex:'100%'}}>
         {this.state.datadocuments.map(p => this.renderItem(p))}
      </div>   
      </div>
      </div>
)
}
}
